import { useLocationAddress } from '@/hooks/useLocationAddress';

interface VehicleAddressProps {
  latitude: number;
  longitude: number;
  companyId?: string;
}

export default function VehicleAddress({ latitude, longitude, companyId }: VehicleAddressProps) {
  const { data: address, isLoading } = useLocationAddress(companyId, latitude, longitude);

  if (isLoading) {
    return (
      <span className="text-muted-foreground animate-pulse">
        Carregando endereço...
      </span>
    );
  }

  if (address?.formatted) {
    return <span>{address.formatted}</span>;
  }

  // Fallback para coordenadas
  return (
    <span className="font-mono text-xs">
      {latitude.toFixed(4)}, {longitude.toFixed(4)}
    </span>
  );
}
